import { auth, db, storage } from "../../firebase";
import React, { useState, useEffect, useMemo } from "react";
import {
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
  writeBatch,
  serverTimestamp,
} from "firebase/firestore";
import { ref, deleteObject } from "firebase/storage";
import { Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";

// IMPORTAMOS LA LIBRERÍA DE EXCEL
import AdminPromociones from "./AdminPromociones";
import AdminMarketing from "./AdminMarketing";
import useMarketingManager from "../../hooks/useMarketingManager";
import AdminInventario from "./AdminInventario";
import AdminProductoForm from "./AdminProductoForm";
import * as XLSX from "xlsx";
import useProductosManager from "../../hooks/useProductosManager";
import AdminAnaliticas from "./AdminAnaliticas";
import AdminConfiguracion from "./AdminConfiguracion";
import AdminDecoraciones from "./AdminDecoraciones";
import AdminLimpieza from "./AdminLimpieza";
import AdminCategorias from "./AdminCategorias";
import {
  crearIdCategoria,
  normalizarTextoCategoria,
} from "../../utils/categorias";

function PanelAdmin() {
  const navigate = useNavigate();

  // CONTROL DE VISTA PRINCIPAL (Pestañas)
  console.log("UID USUARIO:", auth.currentUser?.uid);
  const [pestañaActiva, setPestañaActiva] = useState("registrar");

  // Estados del formulario (Alta / Edición)
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [precio, setPrecio] = useState("");
  const [imagenArchivo, setImagenArchivo] = useState(null);
  const [extrasLista, setExtrasLista] = useState([]);
  const [nombreExtra, setNombreExtra] = useState("");
  const [precioExtra, setPrecioExtra] = useState("");
  const [opcionesSinCosto, setOpcionesSinCosto] = useState([]);
  const [nombreOpcionSinCosto, setNombreOpcionSinCosto] = useState("");
  const [tipoOpcionSinCosto, setTipoOpcionSinCosto] = useState("unica");
  const [requeridaOpcionSinCosto, setRequeridaOpcionSinCosto] = useState(false);
  const [valoresOpcionSinCosto, setValoresOpcionSinCosto] = useState("");
  const [idSeleccionado, setIdSeleccionado] = useState(null);
  const [turno, setTurno] = useState("matutino");
  const [seccion, setSeccion] = useState("");

  // Estados del Inventario General
  const [productos, setProductos] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [categoriasExistentes, setCategoriasExistentes] = useState([]);
  const [mostrarSugerencias, setMostrarSugerencias] = useState(false);
  const [categoriasConfiguradas, setCategoriasConfiguradas] = useState([]);
  const [ordenCategoriaNueva, setOrdenCategoriaNueva] = useState("");
  const cargarCategoriasConfiguradas = async () => {
    try {
      const snapshotCategorias = await getDocs(collection(db, "categorias"));

      const categoriasFirestore = snapshotCategorias.docs.map((documento) => ({
        id: documento.id,
        ...documento.data(),
      }));

      setCategoriasConfiguradas(categoriasFirestore);
    } catch (error) {
      console.error("Error cargando categorías configuradas:", error);
      setMensaje("❌ Error al cargar el orden de categorías.");
    }
  };
  // NUEVOS ESTADOS: Filtros avanzados de la pantalla de Inventario
  const [filtroTurno, setFiltroTurno] = useState("matutino");
  const [filtroSeccion, setFiltroSeccion] = useState("TODAS");
  const [categoriaAEliminar, setCategoriaAEliminar] = useState("");
  const [confirmacionCategoria, setConfirmacionCategoria] = useState("");
  const [eliminandoCategoria, setEliminandoCategoria] = useState(false);
  // ESTADOS GESTIÓN DE MARKETING
  const [banners, setBanners] = useState([]);
  const [especiales, setEspeciales] = useState([]);
  const [tipoMkt, setTipoMkt] = useState("banner");
  const [tituloMkt, setTituloMkt] = useState("");
  const [subtituloMkt, setSubtituloMkt] = useState("");
  const [turnoMkt, setTurnoMkt] = useState("auto");
  const [archivoMarketing, setArchivoMarketing] = useState(null);
  const [cargandoMkt, setCargandoMkt] = useState(false);

  // ✅ Enlazar un Especial con una Promoción (promoId) o Platillo y configurar botón
  const [promoIdMkt, setPromoIdMkt] = useState("");
  const [productoIdMkt, setProductoIdMkt] = useState("");
  const [mostrarBotonMkt, setMostrarBotonMkt] = useState(true);
  const [textoBotonMkt, setTextoBotonMkt] = useState("TOCA PARA PEDIR →");
  const [infoAdicionalMkt, setInfoAdicionalMkt] = useState("");

  // ✅ Modo edición para poder visualizar/editar publicaciones de marketing
  const [modoEdicionMkt, setModoEdicionMkt] = useState(false);
  const [mktEditId, setMktEditId] = useState(null);
  const [mktEditColeccion, setMktEditColeccion] = useState(null); // "marketing" | "especiales"

  // NUEVOS ESTADOS: Gestión Dinámica de Promociones (Mítico Ofertas)
  const [promociones, setPromociones] = useState([]);
  const [tipoPromo, setTipoPromo] = useState("2x1");
  const [productoDetonante, setProductoDetonante] = useState("");
  const [productoRegalo, setProductoRegalo] = useState("");
  const [minimoCompra, setMinimoCompra] = useState("");
  const [cargandoPromo, setCargandoPromo] = useState(false);

  // NUEVO ESTADO: Control de carga masiva
  const [cargandoExcel, setCargandoExcel] = useState(false);

  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const normalizarCategoria = (valor) => {
    return String(valor || "")
      .trim()
      .toUpperCase();
  };
  // 1. Cargar inventario, categorías, banners, especiales y promociones de forma unificada

  const esUrlImagenStorage = (url) => {
    return (
      typeof url === "string" &&
      url.trim() !== "" &&
      url.includes("firebasestorage.googleapis.com")
    );
  };

  const eliminarImagenStorageSiExiste = async (urlImagen) => {
    if (!esUrlImagenStorage(urlImagen)) {
      return { borrada: false, motivo: "No es imagen de Firebase Storage" };
    }

    try {
      const imagenRef = ref(storage, urlImagen);
      await deleteObject(imagenRef);

      return { borrada: true };
    } catch (error) {
      console.warn("No se pudo borrar imagen de Storage:", urlImagen, error);

      return {
        borrada: false,
        motivo: error?.code || "Error desconocido",
      };
    }
  };

  const eliminarOrdenCategoriaYReacomodar = async (nombreCategoria) => {
    const categoriaNormal = normalizarCategoria(nombreCategoria);

    if (!categoriaNormal) {
      return {
        categoriasOrdenBorradas: 0,
        categoriasOrdenReacomodadas: 0,
      };
    }

    const snapshotCategorias = await getDocs(collection(db, "categorias"));

    const categoriasConfiguradas = snapshotCategorias.docs.map((documento) => ({
      id: documento.id,
      ...documento.data(),
    }));

    const categoriasABorrar = categoriasConfiguradas.filter(
      (categoria) => normalizarCategoria(categoria.nombre) === categoriaNormal,
    );

    if (categoriasABorrar.length === 0) {
      return {
        categoriasOrdenBorradas: 0,
        categoriasOrdenReacomodadas: 0,
      };
    }

    const turnosAfectados = Array.from(
      new Set(
        categoriasABorrar.map((categoria) =>
          normalizarCategoria(categoria.turno || "matutino"),
        ),
      ),
    );

    const batch = writeBatch(db);

    let categoriasOrdenBorradas = 0;
    let categoriasOrdenReacomodadas = 0;

    turnosAfectados.forEach((turnoNormal) => {
      const categoriasTurno = categoriasConfiguradas
        .filter(
          (categoria) =>
            normalizarCategoria(categoria.turno || "matutino") === turnoNormal,
        )
        .sort((a, b) => Number(a.orden || 9999) - Number(b.orden || 9999));

      const idsABorrarDelTurno = new Set(
        categoriasABorrar
          .filter(
            (categoria) =>
              normalizarCategoria(categoria.turno || "matutino") ===
              turnoNormal,
          )
          .map((categoria) => categoria.id),
      );

      categoriasTurno.forEach((categoria) => {
        const ordenActual = Number(categoria.orden || 9999);

        if (idsABorrarDelTurno.has(categoria.id)) {
          batch.delete(doc(db, "categorias", categoria.id));
          categoriasOrdenBorradas += 1;
          return;
        }

        const cantidadAntesDeEsta = categoriasTurno.filter((otraCategoria) => {
          return (
            idsABorrarDelTurno.has(otraCategoria.id) &&
            Number(otraCategoria.orden || 9999) < ordenActual
          );
        }).length;

        if (cantidadAntesDeEsta > 0) {
          batch.update(doc(db, "categorias", categoria.id), {
            orden: ordenActual - cantidadAntesDeEsta,
            fechaActualizacion: serverTimestamp(),
          });

          categoriasOrdenReacomodadas += 1;
        }
      });
    });

    await batch.commit();

    return {
      categoriasOrdenBorradas,
      categoriasOrdenReacomodadas,
    };
  };

  const handleAgregarExtraALista = (e) => {
    e.preventDefault();
    if (!nombreExtra || !precioExtra) return;

    setExtrasLista([
      ...extrasLista,
      {
        nombre: nombreExtra,
        precio: Number(precioExtra),
      },
    ]);
    setNombreExtra("");
    setPrecioExtra("");
  };

  const handleEliminarExtraDeLista = (index) => {
    setExtrasLista(extrasLista.filter((_, i) => i !== index));
  };

  const handleAgregarOpcionSinCosto = (e) => {
    e.preventDefault();

    if (!nombreOpcionSinCosto || !valoresOpcionSinCosto) {
      setMensaje("⚠️ Agrega nombre y opciones.");
      return;
    }

    const opciones = valoresOpcionSinCosto
      .split(",")
      .map((opcion) => opcion.trim())
      .filter(Boolean);

    if (opciones.length === 0) {
      setMensaje("⚠️ Agrega al menos una opción válida.");
      return;
    }

    setOpcionesSinCosto([
      ...opcionesSinCosto,
      {
        nombre: nombreOpcionSinCosto.trim(),
        tipo: tipoOpcionSinCosto,
        requerido: requeridaOpcionSinCosto,
        opciones,
      },
    ]);

    setNombreOpcionSinCosto("");
    setTipoOpcionSinCosto("unica");
    setRequeridaOpcionSinCosto(false);
    setValoresOpcionSinCosto("");
  };

  const handleEliminarOpcionSinCosto = (index) => {
    setOpcionesSinCosto(opcionesSinCosto.filter((_, i) => i !== index));
  };

  const turnoCategoriaProducto = useMemo(() => {
    if (turno === "ambos") {
      return "matutino";
    }

    return turno || "matutino";
  }, [turno]);

  const seccionNormalizadaProducto = useMemo(() => {
    return normalizarTextoCategoria(seccion);
  }, [seccion]);

  const categoriasOrdenadasDelTurno = useMemo(() => {
    const turnoNormal = normalizarTextoCategoria(turnoCategoriaProducto);

    return categoriasConfiguradas
      .filter((categoria) => {
        return normalizarTextoCategoria(categoria.turno) === turnoNormal;
      })
      .sort((a, b) => Number(a.orden || 9999) - Number(b.orden || 9999));
  }, [categoriasConfiguradas, turnoCategoriaProducto]);

  const categoriaConfiguradaActual = useMemo(() => {
    if (!seccionNormalizadaProducto) {
      return null;
    }

    return (
      categoriasOrdenadasDelTurno.find(
        (categoria) =>
          normalizarTextoCategoria(categoria.nombre) ===
          seccionNormalizadaProducto,
      ) || null
    );
  }, [categoriasOrdenadasDelTurno, seccionNormalizadaProducto]);

  const categoriaNuevaDetectada = Boolean(
    seccionNormalizadaProducto && !categoriaConfiguradaActual,
  );

  const ordenMaximoCategoriaNueva = categoriasOrdenadasDelTurno.length + 1;

  const categoriaConOrdenOcupadoProducto = useMemo(() => {
    const ordenNuevo = Number(ordenCategoriaNueva);

    if (!ordenNuevo) {
      return null;
    }

    return (
      categoriasOrdenadasDelTurno.find(
        (categoria) => Number(categoria.orden) === ordenNuevo,
      ) || null
    );
  }, [categoriasOrdenadasDelTurno, ordenCategoriaNueva]);

  useEffect(() => {
    if (categoriaNuevaDetectada && !idSeleccionado) {
      setOrdenCategoriaNueva(String(ordenMaximoCategoriaNueva));
      return;
    }

    setOrdenCategoriaNueva("");
  }, [
    categoriaNuevaDetectada,
    idSeleccionado,
    ordenMaximoCategoriaNueva,
    seccionNormalizadaProducto,
    turnoCategoriaProducto,
  ]);

  const {
    cargarProductos,
    handleSubmit,
    handleSeleccionarEditar,
    handleCambiarDisponibilidad,
    handleCargaMasivaExcel,
    limpiarFormulario,
  } = useProductosManager({
    setProductos,
    setCategoriasExistentes,
    setBanners,
    setEspeciales,
    setPromociones,
    setMensaje,
    setCargando,
    setCargandoExcel,
    setPestañaActiva,
    setIdSeleccionado,
    setNombre,
    setDescripcion,
    setPrecio,
    setTurno,
    setSeccion,
    setImagenArchivo,
    setOpcionesSinCosto,
    opcionesSinCosto,
    setExtrasLista,
    productos,
    nombre,
    descripcion,
    precio,
    seccion,
    imagenArchivo,
    turno,
    extrasLista,
    idSeleccionado,

    categoriasConfiguradas,
    categoriaNuevaDetectada,
    ordenCategoriaNueva,
    turnoCategoriaProducto,
    categoriasOrdenadasDelTurno,
    cargarCategoriasConfiguradas,
  });

  const {
    handleMarketingSubmit,
    handleEliminarMarketing,
    handleEditarMarketing,
  } = useMarketingManager({
    banners,
    tipoMkt,
    tituloMkt,
    subtituloMkt,
    turnoMkt,
    promoIdMkt,
    productoIdMkt,
    mostrarBotonMkt,
    textoBotonMkt,
    infoAdicionalMkt,
    archivoMarketing,
    modoEdicionMkt,
    mktEditId,
    mktEditColeccion,
    setMensaje,
    setCargandoMkt,
    setArchivoMarketing,
    setTituloMkt,
    setSubtituloMkt,
    setTurnoMkt,
    setPromoIdMkt,
    setProductoIdMkt,
    setMostrarBotonMkt,
    setTextoBotonMkt,
    setInfoAdicionalMkt,
    setModoEdicionMkt,
    setMktEditId,
    setMktEditColeccion,
    setTipoMkt,
    setPestañaActiva,
    cargarProductos,
  });

  useEffect(() => {
    cargarProductos();
    cargarCategoriasConfiguradas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (pestañaActiva === "registrar") {
      cargarCategoriasConfiguradas();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pestañaActiva]);

  // ✅ Cancelar edición y volver a modo crear
  const handleCancelarEdicionMarketing = () => {
    setModoEdicionMkt(false);
    setMktEditId(null);
    setMktEditColeccion(null);

    setTipoMkt("banner");
    setTituloMkt("");
    setSubtituloMkt("");
    setTurnoMkt("auto");
    setArchivoMarketing(null);
    setPromoIdMkt("");
    setProductoIdMkt("");
    setMostrarBotonMkt(true);
    setTextoBotonMkt("TOCA PARA PEDIR →");
    setInfoAdicionalMkt("");

    const inputMkt = document.getElementById("input-marketing");
    if (inputMkt) inputMkt.value = "";
  };
  // NUEVA FUNCIÓN MÍTICA: Alta y guardado estructurado de promociones en Firestore
  const handlePromoSubmit = async (e) => {
    e.preventDefault();
    setCargandoPromo(true);
    setMensaje("");

    try {
      let esquemaPromo = {
        tipo: tipoPromo,
        fechaCreacion: new Date().toISOString(),
        activa: true,
      };

      if (tipoPromo === "2x1") {
        if (!productoDetonante) {
          setMensaje("⚠️ Por favor selecciona el platillo para el 2x1.");
          setCargandoPromo(false);
          return;
        }
        const elegido = productos.find((p) => p.id === productoDetonante);
        esquemaPromo.productoId = productoDetonante;
        esquemaPromo.nombreProducto = elegido?.nombre || "Producto";
      } else if (tipoPromo === "envio_gratis") {
        if (!minimoCompra) {
          setMensaje("⚠️ Especifica el monto mínimo de compra en pesos.");
          setCargandoPromo(false);
          return;
        }
        esquemaPromo.minimo = Number(minimoCompra);
      } else if (tipoPromo === "regalo") {
        if (!productoDetonante || !productoRegalo) {
          setMensaje(
            "⚠️ Selecciona el platillo detonante y el artículo de regalo.",
          );
          setCargandoPromo(false);
          return;
        }
        const det = productos.find((p) => p.id === productoDetonante);
        const reg = productos.find((p) => p.id === productoRegalo);
        esquemaPromo.detonanteId = productoDetonante;
        esquemaPromo.detonanteNombre = det?.nombre || "Detonante";
        esquemaPromo.regaloId = productoRegalo;
        esquemaPromo.regaloNombre = reg?.nombre || "Regalo";
      }

      await addDoc(collection(db, "promociones"), esquemaPromo);
      setMensaje(
        "🎉 ¡Promoción guardada y activada con éxito en la cocina virtual!",
      );

      // Limpiamos estados del formulario de ofertas
      setProductoDetonante("");
      setProductoRegalo("");
      setMinimoCompra("");
      cargarProductos();
    } catch (error) {
      console.error("Error al guardar promoción:", error);
      setMensaje("❌ Error interno al dar de alta la promoción.");
    } finally {
      setCargandoPromo(false);
    }
  };

  const handleEliminarPromo = async (id) => {
    try {
      await deleteDoc(doc(db, "promociones", id));
      setMensaje("⚙️ Regla de promoción removida con éxito.");
      cargarProductos();
    } catch (error) {
      console.error("Error al borrar promoción:", error);
    }
  };

  const handleTogglePromoActiva = async (id, activaActual) => {
    try {
      await updateDoc(doc(db, "promociones", id), {
        activa: !activaActual,
      });

      setMensaje(
        activaActual
          ? "⚙️ Promoción apagada correctamente."
          : "✅ Promoción activada correctamente.",
      );

      cargarProductos();
    } catch (error) {
      console.error("Error al cambiar estado de promoción:", error);
      setMensaje("❌ Error al cambiar estado de la promoción.");
    }
  };

  const handleEliminarProducto = async (producto) => {
    if (!producto?.id) {
      setMensaje("⚠️ No se pudo identificar el producto a eliminar.");
      return;
    }

    const confirmar = window.confirm(
      `Vas a eliminar el producto "${producto.nombre}".\n\nTambién intentaremos borrar su imagen de Storage si no es una imagen compartida.\n\nEsta acción no se puede deshacer. ¿Continuar?`,
    );

    if (!confirmar) return;

    setMensaje("");

    try {
      const otrosProductosConMismaImagen = productos.filter((item) => {
        return item.id !== producto.id && item.imagen === producto.imagen;
      });

      let imagenBorrada = false;

      if (
        producto.imagen &&
        otrosProductosConMismaImagen.length === 0 &&
        esUrlImagenStorage(producto.imagen)
      ) {
        const resultadoImagen = await eliminarImagenStorageSiExiste(
          producto.imagen,
        );

        imagenBorrada = resultadoImagen?.borrada === true;
      }

      await deleteDoc(doc(db, "productos", producto.id));

      await cargarProductos();

      const productosRestantesMismaCategoria = productos.filter((item) => {
        return (
          item.id !== producto.id &&
          normalizarCategoria(item.seccion) ===
            normalizarCategoria(producto.seccion)
        );
      });

      if (productosRestantesMismaCategoria.length === 0) {
        setMensaje(
          `✅ Producto "${producto.nombre}" eliminado. Imagen borrada: ${
            imagenBorrada ? "sí" : "no"
          }. La categoría "${producto.seccion}" quedó sin productos, pero su orden se conserva por seguridad.`,
        );
        return;
      }

      setMensaje(
        `✅ Producto "${producto.nombre}" eliminado. Imagen borrada: ${
          imagenBorrada ? "sí" : "no"
        }.`,
      );
    } catch (error) {
      console.error("Error eliminando producto:", error);
      setMensaje("❌ Error al eliminar el producto.");
    }
  };

  const handleEliminarCategoriaCompleta = async () => {
    const categoriaNormal = normalizarCategoria(categoriaAEliminar);
    const confirmacionNormal = normalizarCategoria(confirmacionCategoria);

    if (!categoriaNormal) {
      setMensaje("⚠️ Selecciona una categoría para eliminar.");
      return;
    }

    if (confirmacionNormal !== categoriaNormal) {
      setMensaje(`⚠️ Para confirmar, escribe exactamente: ${categoriaNormal}`);
      return;
    }

    const productosDeCategoria = productos.filter(
      (producto) => normalizarCategoria(producto.seccion) === categoriaNormal,
    );

    if (productosDeCategoria.length === 0) {
      setMensaje("⚠️ No encontramos productos dentro de esa categoría.");
      return;
    }

    const confirmar = window.confirm(
      `Vas a borrar ${productosDeCategoria.length} producto(s) de la categoría "${categoriaNormal}". También intentaremos borrar sus imágenes de Storage si ya no las usa otro producto. Esta acción no se puede deshacer. ¿Continuar?`,
    );

    if (!confirmar) return;

    setEliminandoCategoria(true);
    setMensaje("");

    try {
      const productosFueraDeCategoria = productos.filter(
        (producto) => normalizarCategoria(producto.seccion) !== categoriaNormal,
      );

      const imagenesUsadasFueraDeCategoria = new Set(
        productosFueraDeCategoria
          .map((producto) => producto.imagen)
          .filter((imagen) => esUrlImagenStorage(imagen)),
      );

      const imagenesCategoria = Array.from(
        new Set(
          productosDeCategoria
            .map((producto) => producto.imagen)
            .filter((imagen) => esUrlImagenStorage(imagen)),
        ),
      );

      const imagenesParaBorrar = imagenesCategoria.filter(
        (imagen) => !imagenesUsadasFueraDeCategoria.has(imagen),
      );

      const resultadosImagenes = await Promise.allSettled(
        imagenesParaBorrar.map((imagen) =>
          eliminarImagenStorageSiExiste(imagen),
        ),
      );

      const imagenesBorradas = resultadosImagenes.filter(
        (resultado) =>
          resultado.status === "fulfilled" && resultado.value?.borrada,
      ).length;

      await Promise.all(
        productosDeCategoria.map((producto) =>
          deleteDoc(doc(db, "productos", producto.id)),
        ),
      );

      const resultadoOrdenCategorias =
        await eliminarOrdenCategoriaYReacomodar(categoriaNormal);

      setMensaje(
        `✅ Categoría "${categoriaNormal}" eliminada con ${productosDeCategoria.length} producto(s). Imágenes borradas de Storage: ${imagenesBorradas}. Configuraciones de orden borradas: ${resultadoOrdenCategorias.categoriasOrdenBorradas}. Categorías reacomodadas: ${resultadoOrdenCategorias.categoriasOrdenReacomodadas}.`,
      );

      setCategoriaAEliminar("");
      setConfirmacionCategoria("");
      setFiltroSeccion("TODAS");

      await cargarProductos();
    } catch (error) {
      console.error("Error al eliminar categoría completa:", error);
      setMensaje("❌ Error al eliminar la categoría completa.");
    } finally {
      setEliminandoCategoria(false);
    }
  };

  const handleCerrarSesionAdmin = async () => {
    try {
      await signOut(auth);

      window.location.replace("/");
    } catch (error) {
      console.error("Error al cerrar sesión admin:", error);
      setMensaje("❌ No se pudo cerrar sesión.");
    }
  };

  const descargarPlantillaExcelProductos = () => {
    const productosEjemplo = [
      {
        nombre: "New York",
        turno: "vespertino",
        categoria: "CORTES",
        ordenCategoria: 1,
        descripcion: "Corte de 300g con una guarnición",
        precio: 400,
        extras: "Puré papa:20, Verduras grill:20, Papas francesa:20",
        opciones:
          "Término|unica|requerido|Rojo,Medio,Tres Cuartos,Bien Cocido; Guarnición|unica|requerido|Papas francesa,Puré papa,Verduras grill",
      },
      {
        nombre: "Pepito de vacío",
        turno: "vespertino",
        categoria: "PEPITOS",
        ordenCategoria: 2,
        descripcion: "Pepito de vacío con vegetales",
        precio: 180,
        extras: "Queso extra:25, Aguacate:30",
        opciones:
          "Quitar ingredientes|multiple|opcional|Sin cebolla,Sin jitomate,Sin lechuga",
      },
    ];

    const instrucciones = [
      ["COLUMNA", "OBLIGATORIA", "DESCRIPCIÓN", "EJEMPLO"],
      ["nombre", "Sí", "Nombre del producto", "New York"],
      ["turno", "No", "matutino, vespertino o ambos", "vespertino"],
      ["categoria", "Sí", "Categoría o sección del menú", "CORTES"],
      [
        "ordenCategoria",
        "Sí para categorías nuevas",
        "Número de orden en que aparecerá la categoría. La misma categoría debe repetir el mismo número.",
        "1",
      ],
      ["descripcion", "No", "Descripción del producto", "Corte de 300g"],
      ["precio", "Sí", "Precio base del producto", "400"],
      [
        "extras",
        "No",
        "Extras con costo. Separar por coma. Formato: Nombre:Precio",
        "Queso:25, Aguacate:30",
      ],
      [
        "opciones",
        "No",
        "Opciones sin costo. Formato: Nombre|tipo|requerido/opcional|opción1,opción2",
        "Término|unica|requerido|Rojo,Medio,Tres Cuartos; Quitar ingredientes|multiple|opcional|Sin cebolla,Sin jitomate",
      ],
    ];

    const libro = XLSX.utils.book_new();

    const hojaProductos = XLSX.utils.json_to_sheet(productosEjemplo);

    hojaProductos["!cols"] = [
      { wch: 24 },
      { wch: 14 },
      { wch: 18 },
      { wch: 16 },
      { wch: 36 },
      { wch: 12 },
      { wch: 45 },
      { wch: 90 },
    ];

    const hojaInstrucciones = XLSX.utils.aoa_to_sheet(instrucciones);

    hojaInstrucciones["!cols"] = [
      { wch: 18 },
      { wch: 14 },
      { wch: 58 },
      { wch: 80 },
    ];

    XLSX.utils.book_append_sheet(libro, hojaProductos, "Productos");
    XLSX.utils.book_append_sheet(libro, hojaInstrucciones, "Instrucciones");

    XLSX.writeFile(libro, "plantilla-carga-productos-mitico.xlsx");
  };

  // LÓGICA DE FILTRADO FILTRADO AVANZADO
  const seccionesDelTurnoSeleccionado = categoriasExistentes.filter((cat) => {
    if (filtroTurno === "todo") return true;
    return productos.some(
      (p) =>
        p.turno === filtroTurno && p.seccion && p.seccion.toUpperCase() === cat,
    );
  });

  const productosFiltradosEnInventario = productos.filter((p) => {
    const coincideTurno =
      filtroTurno === "todo" ||
      p.turno === filtroTurno ||
      p.turno === "ambos" ||
      (filtroTurno === "ambos" && p.turno === "ambos");

    const coincideSeccion =
      filtroSeccion === "TODAS" ||
      (p.seccion && p.seccion.toUpperCase() === filtroSeccion.toUpperCase());

    const coincideBusqueda =
      p.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
      (p.seccion && p.seccion.toLowerCase().includes(busqueda.toLowerCase()));

    return coincideTurno && coincideSeccion && coincideBusqueda;
  });

  const cantidadProductosCategoriaAEliminar = productos.filter(
    (producto) =>
      normalizarCategoria(producto.seccion) ===
      normalizarCategoria(categoriaAEliminar),
  ).length;

  return (
    <div
      style={{
        padding: "30px",
        fontFamily: "-apple-system, sans-serif",
        maxWidth: "750px",
        margin: "0 auto",
        textAlign: "left",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "12px",
          marginBottom: "10px",
        }}
      >
        <Link
          to="/"
          style={{ color: "#666", textDecoration: "none", fontSize: "14px" }}
        >
          ← Ir a la Tienda
        </Link>

        <button
          onClick={handleCerrarSesionAdmin}
          style={{
            backgroundColor: "#c5221f",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            padding: "8px 12px",
            fontSize: "13px",
            fontWeight: "700",
            cursor: "pointer",
          }}
        >
          Cerrar sesión
        </button>
      </div>

      <h1
        style={{ margin: "15px 0 5px 0", fontSize: "28px", fontWeight: "800" }}
      >
        ⚙️ Backoffice Mítico
      </h1>
      <p style={{ color: "#666", marginBottom: "25px", fontSize: "14px" }}>
        Panel unificado de control operativo para el restaurante.
      </p>

      {/* SISTEMA DE PESTAÑAS AMPLIADO A 4 CATEGORÍAS */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          marginBottom: "25px",
          borderBottom: "2px solid #eee",
          paddingBottom: "10px",
        }}
      >
        <button
          onClick={() => setPestañaActiva("registrar")}
          style={{
            padding: "12px 16px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "700",
            fontSize: "14px",
            backgroundColor: pestañaActiva === "registrar" ? "#000" : "#eee",
            color: pestañaActiva === "registrar" ? "#fff" : "#000",
          }}
        >
          {idSeleccionado ? "📝 Editando Producto" : "➕ Nuevo Platillo"}
        </button>

        <button
          onClick={() => {
            setPestañaActiva("categorias");
            setMensaje("");
          }}
          style={{
            padding: "12px 16px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "700",
            fontSize: "14px",
            backgroundColor: pestañaActiva === "categorias" ? "#111" : "#eee",
            color: pestañaActiva === "categorias" ? "#fff" : "#000",
          }}
        >
          🗂️ Categorías
        </button>

        <button
          onClick={() => {
            setPestañaActiva("inventario");
            setMensaje("");
          }}
          style={{
            padding: "12px 16px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "700",
            fontSize: "14px",
            backgroundColor: pestañaActiva === "inventario" ? "#000" : "#eee",
            color: pestañaActiva === "inventario" ? "#fff" : "#000",
          }}
        >
          📋 Catálogo ({productos.length})
        </button>

        <button
          onClick={() => {
            setPestañaActiva("excel");
            setMensaje("");
          }}
          style={{
            padding: "12px 16px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "700",
            fontSize: "14px",
            backgroundColor: pestañaActiva === "excel" ? "#0b8043" : "#eee",
            color: pestañaActiva === "excel" ? "#fff" : "#000",
          }}
        >
          📥 Carga Excel
        </button>

        <button
          onClick={() => {
            setPestañaActiva("marketing");
            setMensaje("");
          }}
          style={{
            padding: "12px 16px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "700",
            fontSize: "14px",
            backgroundColor: pestañaActiva === "marketing" ? "#FF9900" : "#eee",
            color: pestañaActiva === "marketing" ? "#fff" : "#000",
          }}
        >
          📣 Marketing ({banners.length + especiales.length})
        </button>

        {/* NUEVO BOTÓN DE LA PESTAÑA DE PROMOCIONES */}
        <button
          onClick={() => {
            setPestañaActiva("promociones");
            setMensaje("");
          }}
          style={{
            padding: "12px 16px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "700",
            fontSize: "14px",
            backgroundColor:
              pestañaActiva === "promociones" ? "#4a148c" : "#eee",
            color: pestañaActiva === "promociones" ? "#fff" : "#000",
          }}
        >
          🎟️ Ofertas ({promociones.length})
        </button>

        <button
          onClick={() => {
            setPestañaActiva("analiticas");
            setMensaje("");
          }}
          style={{
            padding: "12px 16px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "700",
            fontSize: "14px",
            backgroundColor:
              pestañaActiva === "analiticas" ? "#1a73e8" : "#eee",
            color: pestañaActiva === "analiticas" ? "#fff" : "#000",
          }}
        >
          📊 Analíticas
        </button>

        <button
          onClick={() => {
            setPestañaActiva("configuracion");
            setMensaje("");
          }}
          style={{
            padding: "12px 16px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "700",
            fontSize: "14px",
            backgroundColor:
              pestañaActiva === "configuracion" ? "#673ab7" : "#eee",
            color: pestañaActiva === "configuracion" ? "#fff" : "#000",
          }}
        >
          ⚙️ Configuración
        </button>
        <button
          onClick={() => {
            setPestañaActiva("decoraciones");
            setMensaje("");
          }}
          style={{
            padding: "12px 16px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "700",
            fontSize: "14px",
            backgroundColor:
              pestañaActiva === "decoraciones" ? "#e91e63" : "#eee",
            color: pestañaActiva === "decoraciones" ? "#fff" : "#000",
          }}
        >
          🎉 Decoraciones
        </button>

        <button
          onClick={() => {
            setPestañaActiva("limpieza");
            setMensaje("");
          }}
          style={{
            padding: "12px 16px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "700",
            fontSize: "14px",
            backgroundColor: pestañaActiva === "limpieza" ? "#b00020" : "#eee",
            color: pestañaActiva === "limpieza" ? "#fff" : "#000",
          }}
        >
          🧹 Limpieza
        </button>
      </div>

      {mensaje && (
        <div
          style={{
            padding: "12px",
            borderRadius: "8px",
            fontSize: "14px",
            marginBottom: "20px",
            fontWeight: "500",
            backgroundColor:
              mensaje.includes("✅") ||
              mensaje.includes("🎉") ||
              mensaje.includes("⚙️")
                ? "#e6f4ea"
                : "#fce8e6",
            color:
              mensaje.includes("✅") ||
              mensaje.includes("🎉") ||
              mensaje.includes("⚙️")
                ? "#137333"
                : "#c5221f",
          }}
        >
          {mensaje}
        </div>
      )}

      {/* PESTAÑA A: REGISTRO DE PRODUCTOS */}
      {pestañaActiva === "registrar" && (
        <AdminProductoForm
          idSeleccionado={idSeleccionado}
          handleSubmit={handleSubmit}
          nombre={nombre}
          setNombre={setNombre}
          turno={turno}
          setTurno={setTurno}
          seccion={seccion}
          setSeccion={setSeccion}
          descripcion={descripcion}
          setDescripcion={setDescripcion}
          precio={precio}
          setPrecio={setPrecio}
          setImagenArchivo={setImagenArchivo}
          categoriasExistentes={categoriasExistentes}
          mostrarSugerencias={mostrarSugerencias}
          setMostrarSugerencias={setMostrarSugerencias}
          opcionesSinCosto={opcionesSinCosto}
          nombreOpcionSinCosto={nombreOpcionSinCosto}
          setNombreOpcionSinCosto={setNombreOpcionSinCosto}
          tipoOpcionSinCosto={tipoOpcionSinCosto}
          setTipoOpcionSinCosto={setTipoOpcionSinCosto}
          requeridaOpcionSinCosto={requeridaOpcionSinCosto}
          setRequeridaOpcionSinCosto={setRequeridaOpcionSinCosto}
          valoresOpcionSinCosto={valoresOpcionSinCosto}
          setValoresOpcionSinCosto={setValoresOpcionSinCosto}
          handleAgregarOpcionSinCosto={handleAgregarOpcionSinCosto}
          handleEliminarOpcionSinCosto={handleEliminarOpcionSinCosto}
          extrasLista={extrasLista}
          nombreExtra={nombreExtra}
          setNombreExtra={setNombreExtra}
          precioExtra={precioExtra}
          setPrecioExtra={setPrecioExtra}
          handleAgregarExtraALista={handleAgregarExtraALista}
          handleEliminarExtraDeLista={handleEliminarExtraDeLista}
          cargando={cargando}
          categoriaConfiguradaActual={categoriaConfiguradaActual}
          categoriaNuevaDetectada={categoriaNuevaDetectada}
          ordenCategoriaNueva={ordenCategoriaNueva}
          setOrdenCategoriaNueva={setOrdenCategoriaNueva}
          ordenMaximoCategoriaNueva={ordenMaximoCategoriaNueva}
          categoriaConOrdenOcupadoProducto={categoriaConOrdenOcupadoProducto}
          categoriasOrdenadasDelTurno={categoriasOrdenadasDelTurno}
        />
      )}

      {/* PESTAÑA EXCEL: CARGA MASIVA DE PRODUCTOS */}
      {pestañaActiva === "excel" && (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #eee",
            borderRadius: "16px",
            padding: "20px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
          }}
        >
          <h2
            style={{
              margin: "0 0 8px 0",
              fontSize: "20px",
              fontWeight: "900",
            }}
          >
            📥 Carga masiva desde Excel
          </h2>

          <p
            style={{
              margin: "0 0 16px 0",
              fontSize: "14px",
              color: "#666",
              lineHeight: "1.5",
            }}
          >
            Sube un archivo Excel con productos para agregarlos automáticamente
            al catálogo.
          </p>

          <div
            style={{
              backgroundColor: "#f8f8f8",
              borderRadius: "12px",
              padding: "14px",
              marginBottom: "16px",
              fontSize: "13px",
              color: "#333",
              lineHeight: "1.6",
            }}
          >
            <strong>Columnas requeridas:</strong>
            <br />
            nombre, precio, categoria, ordenCategoria
            <br />
            <br />
            <strong>Columnas opcionales:</strong>
            <br />
            descripcion, turno, opciones, extras
            <br />
            <br />
            <strong>Importante:</strong>
            <br />
            ordenCategoria es obligatorio cuando la categoría todavía no existe.
            Si varias filas usan la misma categoría, deben repetir el mismo
            ordenCategoria.
            <br />
            <br />
            <strong>Ejemplo:</strong>
            <br />
            nombre: Hamburguesa clásica
            <br />
            precio: 120
            <br />
            categoria: HAMBURGUESAS
            <br />
            ordenCategoria: 1
            <br />
            turno: vespertino
            <br />
            <br />
            <strong>Ejemplo opciones sin costo:</strong>
            <br />
            Término|unica|requerido|Rojo,Medio,3/4,Bien cocido;
            Guarnición|unica|requerido|Papas,Ensalada,Verduras; Quitar
            ingredientes|multiple|opcional|Sin cebolla,Sin jitomate,Sin lechuga
          </div>

          <button
            type="button"
            onClick={descargarPlantillaExcelProductos}
            style={{
              width: "100%",
              backgroundColor: "#111",
              color: "#fff",
              border: "none",
              borderRadius: "12px",
              padding: "14px",
              fontSize: "15px",
              fontWeight: "800",
              cursor: "pointer",
              marginBottom: "14px",
            }}
          >
            📄 Descargar plantilla Excel
          </button>

          <input
            id="input-excel-masivo"
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={handleCargaMasivaExcel}
            disabled={cargandoExcel}
            style={{
              width: "100%",
              padding: "12px",
              border: "1px solid #ddd",
              borderRadius: "12px",
              backgroundColor: "#fff",
              boxSizing: "border-box",
              marginBottom: "14px",
            }}
          />

          <button
            type="button"
            disabled={cargandoExcel}
            style={{
              width: "100%",
              backgroundColor: cargandoExcel ? "#777" : "#0b8043",
              color: "#fff",
              border: "none",
              borderRadius: "12px",
              padding: "14px",
              fontSize: "15px",
              fontWeight: "800",
              cursor: cargandoExcel ? "not-allowed" : "default",
            }}
          >
            {cargandoExcel
              ? "Importando productos..."
              : "Selecciona un archivo para importar"}
          </button>
        </div>
      )}

      {/* PESTAÑA B: AUDITORÍA DE INVENTARIO */}
      {pestañaActiva === "inventario" && (
        <>
          <div
            style={{
              backgroundColor: "#fff",
              border: "1px solid #f3d1d1",
              borderRadius: "16px",
              padding: "18px",
              marginBottom: "18px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
            }}
          >
            <h3
              style={{
                margin: "0 0 8px 0",
                fontSize: "18px",
                fontWeight: "900",
                color: "#8b0000",
              }}
            >
              🗑️ Eliminar categoría completa
            </h3>

            <p
              style={{
                margin: "0 0 14px 0",
                fontSize: "13px",
                color: "#666",
                lineHeight: "1.5",
              }}
            >
              Esta opción borra todos los productos de una categoría. Úsala con
              cuidado, porque no se puede deshacer.
            </p>

            <select
              value={categoriaAEliminar}
              onChange={(e) => {
                setCategoriaAEliminar(e.target.value);
                setConfirmacionCategoria("");
              }}
              disabled={eliminandoCategoria}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "10px",
                border: "1px solid #ddd",
                marginBottom: "10px",
                fontSize: "14px",
                boxSizing: "border-box",
              }}
            >
              <option value="">Selecciona una categoría</option>

              {categoriasExistentes.map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>

            {categoriaAEliminar && (
              <div
                style={{
                  backgroundColor: "#fff4f4",
                  border: "1px solid #ffd0d0",
                  borderRadius: "12px",
                  padding: "12px",
                  marginBottom: "10px",
                  fontSize: "13px",
                  color: "#8b0000",
                  fontWeight: "700",
                }}
              >
                Se eliminarán {cantidadProductosCategoriaAEliminar} producto(s)
                de la categoría: {normalizarCategoria(categoriaAEliminar)}
              </div>
            )}

            <input
              type="text"
              value={confirmacionCategoria}
              onChange={(e) => setConfirmacionCategoria(e.target.value)}
              placeholder={
                categoriaAEliminar
                  ? `Escribe ${normalizarCategoria(categoriaAEliminar)} para confirmar`
                  : "Primero selecciona una categoría"
              }
              disabled={!categoriaAEliminar || eliminandoCategoria}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "10px",
                border: "1px solid #ddd",
                marginBottom: "12px",
                fontSize: "14px",
                boxSizing: "border-box",
              }}
            />

            <button
              type="button"
              onClick={handleEliminarCategoriaCompleta}
              disabled={
                !categoriaAEliminar ||
                eliminandoCategoria ||
                normalizarCategoria(confirmacionCategoria) !==
                  normalizarCategoria(categoriaAEliminar)
              }
              style={{
                width: "100%",
                backgroundColor:
                  !categoriaAEliminar ||
                  eliminandoCategoria ||
                  normalizarCategoria(confirmacionCategoria) !==
                    normalizarCategoria(categoriaAEliminar)
                    ? "#bbb"
                    : "#b00020",
                color: "#fff",
                border: "none",
                borderRadius: "12px",
                padding: "13px",
                fontSize: "14px",
                fontWeight: "900",
                cursor:
                  !categoriaAEliminar ||
                  eliminandoCategoria ||
                  normalizarCategoria(confirmacionCategoria) !==
                    normalizarCategoria(categoriaAEliminar)
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              {eliminandoCategoria
                ? "Eliminando categoría..."
                : "Eliminar categoría completa"}
            </button>
          </div>

          <AdminInventario
            filtroTurno={filtroTurno}
            setFiltroTurno={setFiltroTurno}
            filtroSeccion={filtroSeccion}
            setFiltroSeccion={setFiltroSeccion}
            seccionesDelTurnoSeleccionado={seccionesDelTurnoSeleccionado}
            productosFiltradosEnInventario={productosFiltradosEnInventario}
            handleSeleccionarEditar={handleSeleccionarEditar}
            handleCambiarDisponibilidad={handleCambiarDisponibilidad}
            handleEliminarProducto={handleEliminarProducto}
          />
        </>
      )}

      {/* PESTAÑA CATEGORÍAS */}
      {pestañaActiva === "categorias" && (
        <AdminCategorias setMensaje={setMensaje} />
      )}

      {/* PESTAÑA C: AJUSTES DE MARKETING (Banners y Popups) */}
      {pestañaActiva === "marketing" && (
        <AdminMarketing
          modoEdicionMkt={modoEdicionMkt}
          handleCancelarEdicionMarketing={handleCancelarEdicionMarketing}
          tipoMkt={tipoMkt}
          setTipoMkt={setTipoMkt}
          tituloMkt={tituloMkt}
          setTituloMkt={setTituloMkt}
          subtituloMkt={subtituloMkt}
          setSubtituloMkt={setSubtituloMkt}
          turnoMkt={turnoMkt}
          setTurnoMkt={setTurnoMkt}
          promoIdMkt={promoIdMkt}
          setPromoIdMkt={setPromoIdMkt}
          productoIdMkt={productoIdMkt}
          setProductoIdMkt={setProductoIdMkt}
          mostrarBotonMkt={mostrarBotonMkt}
          setMostrarBotonMkt={setMostrarBotonMkt}
          textoBotonMkt={textoBotonMkt}
          setTextoBotonMkt={setTextoBotonMkt}
          infoAdicionalMkt={infoAdicionalMkt}
          setInfoAdicionalMkt={setInfoAdicionalMkt}
          productos={productos}
          promociones={promociones}
          setArchivoMarketing={setArchivoMarketing}
          handleMarketingSubmit={handleMarketingSubmit}
          cargandoMkt={cargandoMkt}
          banners={banners}
          especiales={especiales}
          handleEditarMarketing={handleEditarMarketing}
          handleEliminarMarketing={handleEliminarMarketing}
        />
      )}

      {/* NUEVA PESTAÑA D: INTERFAZ DE CONTROL PARA PROMOCIONES Y OFERTAS AUTOMÁTICAS */}
      {pestañaActiva === "promociones" && (
        <AdminPromociones
          promociones={promociones}
          productos={productos}
          tipoPromo={tipoPromo}
          setTipoPromo={setTipoPromo}
          productoDetonante={productoDetonante}
          setProductoDetonante={setProductoDetonante}
          productoRegalo={productoRegalo}
          setProductoRegalo={setProductoRegalo}
          minimoCompra={minimoCompra}
          setMinimoCompra={setMinimoCompra}
          handlePromoSubmit={handlePromoSubmit}
          cargandoPromo={cargandoPromo}
          handleEliminarPromo={handleEliminarPromo}
          handleTogglePromoActiva={handleTogglePromoActiva}
        />
      )}

      {/* PESTAÑA ANALÍTICAS */}
      {pestañaActiva === "analiticas" && <AdminAnaliticas />}
      {/* PESTAÑA CONFIGURACIÓN */}
      {pestañaActiva === "configuracion" && <AdminConfiguracion />}
      {/* PESTAÑA DECORACIONES */}
      {pestañaActiva === "decoraciones" && <AdminDecoraciones />}
      {/* PESTAÑA LIMPIEZA */}
      {pestañaActiva === "limpieza" && (
        <AdminLimpieza
          setMensaje={setMensaje}
          onLimpiezaCompletada={cargarProductos}
        />
      )}
    </div>
  );
}

export default PanelAdmin;
